/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GolabAppWithChangedMasterTranslationFile } from '../../models/golab-app-with-changed-master-translation-file';

export interface GolabControllerCheckMasterTranslationUrlsForGolabAppsAndLabs$Params {
}

export function golabControllerCheckMasterTranslationUrlsForGolabAppsAndLabs(http: HttpClient, rootUrl: string, params?: GolabControllerCheckMasterTranslationUrlsForGolabAppsAndLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppWithChangedMasterTranslationFile>>> {
  const rb = new RequestBuilder(rootUrl, golabControllerCheckMasterTranslationUrlsForGolabAppsAndLabs.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GolabAppWithChangedMasterTranslationFile>>;
    })
  );
}

golabControllerCheckMasterTranslationUrlsForGolabAppsAndLabs.PATH = '/golab/check-master-translation-urls-for-golab-apps-and-labs';
